export default __webpack_public_path__ + "static/multimodal-input-dark-d78e0d71f10cc034c54638c217ab1316.png";